import { useEffect, useState, useRef } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useLazyQuery, useMutation } from "@apollo/client";
import Layout from "shared/Layout";
import Dropdown from "shared/Components/trialStatusDropdown";
import TrialStatusDropdown from "shared/Components/trialStatusDropdown";
import { MobilePagination } from "shared/Components/mobilePagination";
import { SearchLocation } from "shared/Components/searchLocation";
import { TrailMobileCard } from "./components/MobileCard";
import { DEFAULT_DATE_FORMAT, LEVEL_DROPDOWN_DATA } from "helper/utility";
import { globalVariables } from "helper/globalVariables";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import { globalClasses } from "helper/globalClasses";
import {
  TrialCalendarQuery,
  UPDATE_TRIAL_APPROVAL_MUTATION,
  deleteTrialCalendarByAdminMutation,
} from "redux/features/trialCalendar/trialCalendarGql";
import { PopUpMessages } from "shared/Components/popUpMessages";
import Loader from "shared/Components/loader";
import ThreeDotMenu from "shared/Components/threeDotMenu";
import { client } from "helper/apolloConfig";
import {
  setHostDetails,
  setSearchDetails,
  setTrialDetails,
} from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { useDispatch } from "react-redux";
import { getAllJudgeQuery } from "redux/features/hostSlice/addTrialSlice/addTrialGql";
import { CustomDateRangePicker } from "shared/Components/customDateRangePicker";
import { SkipModal } from "container/OnBoarding/RegisterDog/Components/SkipModal";
import PageInfo from "shared/Components/pageInfo";
import { Button } from "shared/Components/button";
import { TrailResultDetailsQuery } from "redux/features/trailResultSlice/trailResultGql";
import { useUploadFileMutation } from "redux/features/trailResults/uploadFileApiSlice";
import Modal from "shared/Components/modal";

const columns = [
  {
    label: globalVariables.date,
    style: "",
  },
  {
    label: globalVariables.trialName,
    style: "",
  },
  {
    label: globalVariables.city,
    style: "",
  },
  {
    label: globalVariables.state,
    style: "",
  },

  // {
  //   label: globalVariables.zipCode,
  //   style: "",
  // },

  // {
  //   label: globalVariables.location,
  //   style: "pl-0 !text-left",
  // },
  // {
  //   label: globalVariables.level,
  //   style: "pl-0 !text-left",
  // },
  {
    label: globalVariables.host,
    style: "pl-0 !text-left",
  },
  {
    label: globalVariables.openDate,
    style: "",
  },
  {
    label: globalVariables.closeDate,
    style: "",
  },
  {
    label: globalVariables.cutoffDate,
    style: "",
  },
  {
    label: globalVariables.entries,
    style: "",
  },
  {
    label: globalVariables.trailStatus,
    style: "",
  },
  {
    label: globalVariables.approvalStatus,
    style: "",
  },
];

const TrailStatus = [
  { label: "Upcoming", value: globalVariables.upcoming },
  { label: "Pending", value: globalVariables.pending },
  { label: "Open", value: globalVariables.open },
  { label: "Closed", value: globalVariables.close },
];

const ApproveStatus = [
  { label: "Approved", value: globalVariables.approve },
  { label: "Rejected", value: globalVariables.reject },
  { label: "Pending", value: globalVariables.pending },
];

const TableApproveStatus = [
  { label: "Approved", value: globalVariables.approve },
  { label: "Reject", value: globalVariables.reject },
  { label: "Pending", value: globalVariables.pending },
];

function getLabelFromValue(value) {
  const status = ApproveStatus.find((item) => item.value === value);
  return status ? status.label : "Unknown Status";
}

const threeDotData = [globalVariables.edit, globalVariables.delete, "Upload Results"];

const ManageTrail = () => {
  const popUpModalRef = useRef();
  const modalRef = useRef();
  const uploadModalRef = useRef();

  const navigate = useNavigate();
  const [judgesDropdownData, setJudgesDropdownData] = useState([]);
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [selectedTrialForUpload, setSelectedTrialForUpload] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const uploadRequestRef = useRef(null);

  const [getData, { loading, error, data, refetch }] = useLazyQuery(
    TrialCalendarQuery,
    { fetchPolicy: "network-only" }
  );

  const [checkTrialResults] = useLazyQuery(TrailResultDetailsQuery, {
    fetchPolicy: "network-only"
  });

  const [uploadFileMutation] = useUploadFileMutation();
  const [updateTrialApprovalStatus] = useMutation(
    UPDATE_TRIAL_APPROVAL_MUTATION
  );
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const [page, setPage] = useState(1);
  const { paginatedDataCls } = globalClasses;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const dispatch = useDispatch();
  const options = LEVEL_DROPDOWN_DATA.map((data, index) => ({
    label: data,
    value: `option_${index}`,
  }));

  const [filters, setFilters] = useState({
    city: "",
    state: "",
    level: "",
    trialStatus: "",
    // approvalStatus: null,
    pageNumber: page,
    pageSize: 10,
    fromDate: null,
    toDate: null,
  });
  useEffect(() => {
    getData({
      variables: filters,
    });
  }, [filters, page]);

  const resultData = data?.getAllTrialCalendar;
  const trials = resultData?.data || [];

  useEffect(() => {
    const getJudges = async () => {
      try {
        const result = await client.query({
          query: getAllJudgeQuery,
          variables: {
            search: "",
          },
        });

        let data = result?.data?.getAllJudge;
        if (data) {
          setJudgesDropdownData(data);
        }
      } catch (err) {}
    };

    getJudges();
  }, []);

  const onCloseModal = () => {
    if (apiData.type === "success") {
      handlePaginationData();
    }
  };

  const handlePaginationData = (pages = 1) => {
    setPage(pages);
    onChange(pages, "pageNumber");
  };

  const closeUploadModal = () => {
    setShowUploadModal(false);
    setSelectedTrialForUpload(null);
    setUploadFile(null);
  };

  const handleCancelUpload = () => {
    if (uploading && uploadRequestRef.current?.abort) {
      uploadRequestRef.current.abort();
    }
    uploadRequestRef.current = null;
    setUploading(false);
    closeUploadModal();
  };

  const handleFileUpload = async () => {
    if (!uploadFile || !selectedTrialForUpload) return;

    setUploading(true);
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("trialCalendarId", selectedTrialForUpload.id);

    const request = uploadFileMutation(formData);
    uploadRequestRef.current = request;

    try {
      await request.unwrap();

      closeUploadModal();
      setApiData({
        title: "Success!",
        desc: "Trial results uploaded successfully!",
        type: "success",
      });
      popUpModalRef.current?.openModal();
      refetch();
    } catch (error) {
      // Request was aborted by the user via Cancel - stay silent, UI is already reset.
      if (error?.name === "AbortError" || error?.message === "Aborted") {
        return;
      }
      closeUploadModal();
      setApiData({
        title: "Upload Failed",
        desc: error?.data?.message || "Failed to upload trial results. Please try again.",
        type: "error",
      });
      popUpModalRef.current?.openModal();
    } finally {
      uploadRequestRef.current = null;
      setUploading(false);
    }
  };

  const onSelectOption = async (option, data) => {
    // Handle Upload Results option
    if (option === "Upload Results") {
      let hasResults = false;
      try {
        const resultCheck = await checkTrialResults({
          variables: {
            id: String(data.id),
            pageNumber: 1,
            pageSize: 1
          }
        });
        hasResults = resultCheck?.data?.getTrialResultByTrialCalendar?.data?.length > 0;
      } catch (error) {
        console.error("Error checking trial results:", error);
        // Fall through - let backend's duplicate guard reject if results actually exist.
      }

      if (hasResults) {
        setApiData({
          title: "Results Already Uploaded",
          desc: "Trial results have already been uploaded for this trial. You cannot upload results again.",
          type: "error",
        });
        popUpModalRef.current?.openModal();
      } else {
        setSelectedTrialForUpload(data);
        setShowUploadModal(true);
        setTimeout(() => uploadModalRef.current?.openModal(), 100);
      }
      return;
    }

    const {
      trialName,
      trialLocationName,
      trialLocationAddress,
      city: trialCity,
      state: trialState,
      zip: trialZip,
      description,
      notes,
      timezone,
      noOfJudge,
      trialDate,
      closeDate,
      openDate,
      cutoffDate,
      trialImages,
      trialFile,
      judgeAuthId,
      maxEntries,
    } = data?.trial || {};
    const {
      hostName,
      contactAddress,
      city,
      state,
      trialSecretaryEmail,
      trialSecretaryName,
      zip,
      paypalEmail,
      paypalPaymentLink,
    } = data?.host || {};
    const trialImagesName = trialImages?.split("/");
    const trialFileName = trialFile?.split("/");
    const searchRes = data?.search;
    const searchData = searchRes?.map((e) => ({
      title: e?.element,
      levelNovice: e?.level,
      elements: e?.element,
      searchName: e?.searchName,
      entryFee: e?.entryFee,
    }));
    const judgeData = [];
    judgeAuthId?.map((e) => {
      const detail = judgesDropdownData.filter((ele) => ele?.authId === e)?.[0];

      judgeData.push({
        value: detail?.name,
        label: detail?.name,
        authId: detail?.authId,
      });
    });

    switch (option) {
      case globalVariables.edit:
        dispatch(
          setHostDetails({
            hostName,
            contactAddress,
            hostPaypalEmail: paypalEmail,
            paypalPaymentLink: paypalPaymentLink,
            trialSecretaryName,
            trialSecretaryEmailAddress: trialSecretaryEmail,
            zip,
            city,
            state,
          })
        );
        dispatch(
          setTrialDetails({
            trialName,
            trialLocationName,
            trialLocationAddress,
            city: trialCity,
            state: trialState,
            zip: trialZip,
            description,
            notes,
            maxEntries,
            numberOfJudges: noOfJudge,
            timeZone: timezone,
            trialDate,
            openDate,
            closeDate,
            cutoffDate,
            image: trialFile,
            fileName: trialFileName[trialFileName?.length - 1],
            fileSize: "100KB",
            addedJudges: judgeData,
          })
        );
        dispatch(setSearchDetails(searchData));
        navigate("/admin/manage/trailEditTrial", { state: { id: data?.id } });
        break;
      case globalVariables.delete: {
        modalRef.current.openModal();
        break;
      }
      default:
        break;
    }
  };

  const onDelete = async () => {
    setDeleteLoading(true);
    try {
      const result = await client.mutate({
        mutation: deleteTrialCalendarByAdminMutation,
        variables: { trialCalendarId: parseInt(trials[selectedIndex]?.id) },
      });

      setDeleteLoading(false);
      if (result?.data?.deleteTrialCalendarByAdmin) {
        popUpModalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.success,
          desc: result?.data?.deleteTrialCalendarByAdmin?.message,
          type: "success",
        });
      }
    } catch (error) {
      setDeleteLoading(false);
      popUpModalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: error?.message,
        type: "pending",
      });
    }
  };

  const renderButton = (trailStatus, id) => {
    return (
      <>
        {loadingRowId === id ? (
          <Loader />
        ) : (
          <TrialStatusDropdown
            width={"w-[150px]"}
            dropdownOptions={TableApproveStatus}
            defaultOption={trailStatus}
            mainContent="w-100%"
            onChange={(option) => onChangeStatus(option.value, id)}
          />
        )}
      </>
    );
  };

  const onRowClick = (id, trial) => {
    navigate(`/admin/manage/trial/${id}`, { state: { customData: trial } });
  };

  const renderTableBody = () => {
    return trials?.map((trial, index) => {
      return (
        <tr
          key={trial.id}
          onClick={() => onRowClick(trial.id, trial)}
          className={`cursor-pointer 
            ${
              trial?.trial?.status == "Open"
                ? "bg-lightGreen"
                : trial?.trial?.status == "Close"
                ? "bg-lightRed"
                : "bg-white"
            }`}          
        >
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {moment.utc(trial?.trial?.trialDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[150px]")}>
            {trial?.trial?.trialName || "-"}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {trial?.trial?.city}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {trial?.trial?.state}
          </td>
          {/* <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {trial?.trial?.zip}
          </td> */}
          {/* <td
            className={`${paginatedDataCls(index)} w-[200px] pl-0 !text-left`}
          >
            {trial?.trial?.trialLocationAddress}
          </td> */}
          {/* <td className={`${paginatedDataCls(index)} pl-0 !text-left`}>
            {trial?.search?.map((search) => search?.level).join(", ")}
          </td> */}
          <td className={`${paginatedDataCls(index)} pl-0 !text-left`}>
            {trial?.host?.hostName}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {moment.utc(trial?.trial?.openDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {moment.utc(trial?.trial?.closeDate).format(DEFAULT_DATE_FORMAT)}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {trial?.trial?.cutoffDate ? moment.utc(trial?.trial?.cutoffDate).format(DEFAULT_DATE_FORMAT) : "-"}
          </td>
          <td className={paginatedDataCls(index, "min-w-[130px]")}>
            {trial?.noOfEntries}
          </td>
          <td className={paginatedDataCls(index,"min-w-[130px]")}>
            <span
              className={`
                ${
                  trial?.trial?.status == "Open"
                    ? "text-green font-semibold"
                    : trial?.trial?.status == "Close"
                    ? "text-red font-semibold"
                    : ""
                }`}
            >
              {trial?.trial?.status == "Close" ? "Closed" : trial?.trial?.status}
            </span>
          </td>
          <td
           className={paginatedDataCls(index, "min-w-[130px]")}
          >
            <div className="flex flex-row justify-center items-center">
              {renderButton(trial?.trial?.approvalStatus, trial.id)}
              <div className="mr-4" />
              {deleteLoading && index === selectedIndex ? (
                <Loader />
              ) : (
                <ThreeDotMenu
                  onClickDot={() => setSelectedIndex(index)}
                  options={threeDotData}
                  dynamicHeight
                  onSelectOption={(option) => {
                    onSelectOption(option, trial);
                  }}
                  threeDotWidth="w-[20px]"
                />
              )}
            </div>
          </td>
        </tr>
      );
    });
  };

  const onChangeStatus = async (value, id) => {
    try {
      setLoadingRowId(id);
      const { data } = await updateTrialApprovalStatus({
        variables: {
          id: parseInt(id),
          approvalStatus: value,
        },
      });
      setApiData({
        title: "Success",
        desc: data.updateTrialApprovalStatus.message,
        type: "success",
      });
      await refetch();
      popUpModalRef.current.openModal();
      setLoadingRowId(null);
    } catch (error) {
      setLoadingRowId(null);
      setApiData({
        title: "error",
        desc: error.message,
        type: "pending",
      });
    }
  };

  const onChange = (value, key) => {
    setFilters({
      ...filters,
      [key]: value,
    });
  };

  // const MobileListing = () => {
  //   return (
  //     <div className="mt-[20px]">
  //       <div className="pb-[12px]">
  //         {trials?.map((data, index) => (
  //           <TrailMobileCard
  //             data={data}
  //             key={index.toString()}
  //             index={index}
  //             onChangeStatus={(option) => onChangeStatus(option, data?.id)}
  //             loadingRowId={loadingRowId}
  //             statusLoading={false}
  //             onClick={() => {}}
  //           />
  //         ))}
  //       </div>
  //       <MobilePagination
  //         currentPage={resultData?.pageNumber}
  //         totalPages={resultData?.totalPages}
  //         handlePageChange={(page) => handlePaginationData(page)}
  //       />
  //     </div>
  //   );
  // };

 const onClearFilters = () => {
    setFilters((prev) => ({
      ...prev,
      fromDate: null,
      toDate: null,
      city: "",
      state: "",
      level: "",
      trialStatus: ""
    }));
  };

  return (
    <div className={`App lg:rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10`}>
        <PageInfo title={globalVariables.trailManagement}>
          <Button
            width={"w-auto"}
            label="Clear All Filters"
            onClick={onClearFilters} 
          />
        </PageInfo>
        <div
          className={"grid md:grid-cols-2 lg:grid-cols-5 gap-5 my-5"}
        >
          <CustomDateRangePicker
            defaultStartDate={filters.fromDate}
            defaultEndDate={filters.toDate}
            isShadow={true}
            width={"w-full"}
            onSetDate={(startDate, endDate) => {
              setFilters({
                ...filters,
                fromDate: startDate
                  ? moment(startDate).format("yyyy-MM-01")
                  : null,
                toDate: endDate
                  ? moment(endDate).format("yyyy-MM-31")
                  : null,
              });
            }}
          />
        <SearchLocation
          isShadow={true}
          width={"w-full"}
          name="State"
          placeholder={globalVariables.state}
          types={["(regions)"]}
          onSelectLocation={(location) => {
            onChange(location, "state");
          }}
          defaultValue={filters.state}
        />
        <SearchLocation
          isShadow={true}
          width={"w-full"}
          name="city"
          placeholder={globalVariables.city}
          types={["(cities)"]}
          onSelectLocation={(location) => {
            onChange(location, "city");
          }}
          searchBy={filters.state}
          defaultValue={filters.city}
        />
        <Dropdown
          isShadow={true}
          width={"w-full"}
          placeholder={globalVariables.level}
          dropdownOptions={options}
          showIconLeft={true}
          showCross
          onChange={(option) => {
            onChange(option.label, "level");
          }}
          defaultOption={filters.level}
        />
        <TrialStatusDropdown
          defaultOption={filters.trialStatus}
          isShadow={true}
          width={"w-full"}
          placeholder={globalVariables.trailStatus}
          dropdownOptions={TrailStatus}
          showIconLeft={true}
          showCross
          onChange={(option) => onChange(option.value, "trialStatus")}
        />
      </div>
        <div className={`mt-[20px] md:hidden`}>
          <>
            {!loading && !error && (
              <div className="mt-[20px]">
                <div className="pb-[12px]">
                  {trials.length === 0 && !loading ? (
                    <div className="flex justify-center items-center h-full min-h-[10rem]">
                      <span className="font-semibold text-xl text-gray-900">
                        {error?.message ? "Something went wrong" : "No Records"}
                      </span>
                    </div>
                  ) : (
                    trials?.map((data, index) => (
                      <TrailMobileCard
                        data={data}
                        key={index.toString()}
                        index={index}
                        onChangeStatus={(option) =>
                          onChangeStatus(option, data?.id)
                        }
                        loadingRowId={loadingRowId}
                        statusLoading={false}
                        onClick={() => {}}
                        threeDotData={threeDotData}
                        deleteLoading={deleteLoading}
                        onSelectOption={(option) => {
                          onSelectOption(option, data);
                        }}
                      />
                    ))
                  )}
                </div>
                {resultData?.totalPages > 1 ? (
                  <MobilePagination
                    currentPage={resultData?.pageNumber}
                    totalPages={resultData?.totalPages}
                    handlePageChange={(page) => handlePaginationData(page)}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </>
        </div>
        <div className="hidden md:block md:mt-[16px] lg:block lg:mt-8">
          <TableWithPagination
            headData={columns}
            headDateWithStyle={true}
            tableBody={renderTableBody()}
            loading={loading}
            error={error}
            isHeaderComponentRow={true}
            itemsPerPage={10}
            totalPage={resultData?.totalPages}
            handlePageChange={(page) => handlePaginationData(page)}
            tableHeight={"md:h-[calc(100vh-15rem)] lg:h-[100vh]"}
          />
        </div>
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={popUpModalRef}
        onCloseModal={onCloseModal}
      />
      <SkipModal
        ModalHeader={globalVariables.sureDeleteTrial}
        ModalContent={""}
        ref={modalRef}
        hasSecondaryButton={false}
        isCenter={true}
        primaryLabel={globalVariables.deleteTrial}
        onSkip={onDelete}
        showClose={true}
      />

      {/* Modal for Upload Trial Results */}
      {showUploadModal && selectedTrialForUpload && (
        <Modal ref={uploadModalRef}>
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-lg w-full">
            <div className="mb-4">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Upload Trial Results
              </h2>
            </div>

            <div className="mb-4">
              <p className="text-sm text-gray-600 mb-2">
                <strong>Trial:</strong> {selectedTrialForUpload?.trial?.trialName}
              </p>
              <p className="text-sm text-gray-600 mb-4">
                <strong>Date:</strong> {selectedTrialForUpload?.trial?.trialDate ? moment.utc(selectedTrialForUpload.trial.trialDate).format('MMMM DD, YYYY') : 'N/A'}
              </p>
            </div>

            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
              <input
                type="file"
                accept=".csv,.xlsx"
                onChange={(e) => setUploadFile(e.target.files[0])}
                className="hidden"
                id="upload-file"
              />
              <label
                htmlFor="upload-file"
                className="cursor-pointer"
              >
                {uploadFile ? (
                  <div>
                    <svg className="mx-auto h-12 w-12 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="mt-2 text-sm text-gray-600">
                      <strong>{uploadFile.name}</strong>
                    </p>
                    <p className="mt-1 text-xs text-gray-500">
                      Click to change file
                    </p>
                  </div>
                ) : (
                  <div>
                    <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
                      <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p className="mt-2 text-sm text-gray-600">
                      <strong>Click to upload</strong> or drag and drop
                    </p>
                    <p className="mt-1 text-xs text-gray-500">
                      CSV or Excel files
                    </p>
                  </div>
                )}
              </label>
            </div>

            {uploading && (
              <p className="mt-4 text-xs text-gray-500 text-center">
                Large files can take up to 5 minutes. Please don't close this tab.
              </p>
            )}
            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={handleCancelUpload}
                className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleFileUpload}
                disabled={!uploadFile || uploading}
                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-purple-800 disabled:bg-gray-300 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2"
              >
                {uploading && (
                  <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                  </svg>
                )}
                {uploading ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};
export default ManageTrail;
